import { render, staticRenderFns } from "./ToggleSwitchTable.vue?vue&type=template&id=4dc497f6&"
import script from "./ToggleSwitchTable.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports